import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { StatisticalDataRoutingModule } from './statistical-data-routing.module';
import { WheatProcurementDataComponent } from './wheat-procurement-data/wheat-procurement-data.component';
import { StatisticalDataComponent } from './statistical-data.component';
import { HeadquarterModule } from '../headquarter.module';
import { StatisticalDataSidenavComponent } from './includes/statistical-data-sidenav/statistical-data-sidenav.component';
import { FarmersBanefitedComponent } from './farmers-banefited/farmers-banefited.component';
import { RiceComponent } from './rice/rice.component';
import { PaddyComponent } from './paddy/paddy.component';
import { CoarseComponent } from './coarse/coarse.component';
import { StockComponent } from './stock/stock.component';
import { QualityControlComponent } from './quality-control/quality-control.component';
import { MovementComponent } from './movement/movement.component';
import { IrLComponent } from './ir-l/ir-l.component';
import { DepartmentalLaborComponent } from './departmental-labor/departmental-labor.component';
import { LabourStrengthComponent } from './labour-strength/labour-strength.component';
import { ImportExportComponent } from './import-export/import-export.component';
import { ImportWheatComponent } from './import-wheat/import-wheat.component';
import { FormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
export const HttpLoaderFactory= (http:HttpClient) =>{
  let siteURL= environment.siteURL;
  return new TranslateHttpLoader(http,siteURL+'assets/language/','.json')
}

@NgModule({
  declarations: [
    WheatProcurementDataComponent,
    StatisticalDataComponent,
    StatisticalDataSidenavComponent,
    FarmersBanefitedComponent,
    RiceComponent,
    PaddyComponent,
    CoarseComponent,
    StockComponent,
    QualityControlComponent,
    MovementComponent,
    IrLComponent,
    DepartmentalLaborComponent,
    LabourStrengthComponent,
    ImportExportComponent,
    ImportWheatComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    StatisticalDataRoutingModule,
    HeadquarterModule, 
    NgxPaginationModule,
     //FOR LANGUAGE CONVERSION - STARTS
     TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
    //FOR LANGUAGE CONVERSION - ENDS
  ]
})
export class StatisticalDataModule { }
